import BigNumber from 'bignumber.js'

import styled from 'styled-components'
import { BIG_ZERO } from 'utils/bigNumber'
import { Flex, Text, Box } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import { PoolCategory } from 'config/constants/types'
import { useProfileRequirement } from 'views/Pools/hooks/useProfileRequirement'
import { DeserializedPool } from 'state/types'
import ApprovalAction from './ApprovalAction'
import StakeActions from './StakeActions'
import HarvestActions from './HarvestActions'
import { ProfileRequirementWarning } from '../../ProfileRequirementWarning'
import { usePool } from 'state/pools/hooks'

const InlineText = styled(Text)`
  display: inline;
`

interface CardActionsProps {
  pool: DeserializedPool
  stakedBalance: BigNumber
}

const CardActions: React.FC<CardActionsProps> = ({ pool, stakedBalance }) => {
  const { sousId, stakingToken, earningToken, harvest, poolCategory, userData, earningTokenPrice, profileRequirement } =
    pool

  // Pools using native BNB behave differently than pools using a token
  const isBnbPool = poolCategory === PoolCategory.BINANCE
  const { t } = useTranslation()
  const allowance = userData?.allowance ? new BigNumber(userData.allowance) : BIG_ZERO
  //const calcAllowance = allowance.minus(userData?.stakingTokenBalance.plus(stakedBalance))
  const stakingTokenBalance =
    pool.stakingToken.symbol == 'GF'
      ? userData?.gfTokenIds
        ? new BigNumber(
            userData.gfTokenIds.filter(
              (id) => id >= pool.allowedTokenIds?.from && id <= pool.allowedTokenIds?.to,
            ).length,
          )
        : BIG_ZERO
      : userData.stakingTokenBalance

  const needsApproval = pool.isNft
    ? allowance.eq(0) && !isBnbPool
    : (allowance.eq(0) || !allowance.gte(stakingTokenBalance)) && !isBnbPool
  const isStaked = stakedBalance.gt(0)
  const earnings = isStaked && userData?.pendingReward ? new BigNumber(userData.pendingReward) : BIG_ZERO
  const isLoading = !userData
  const withdrawFee = pool.withdrawFee ? pool.withdrawFee : false

  const nftPrice = pool.earningToken.symbol === 'HH' ? 0.2 : pool.earningToken.symbol === 'GF' ? pool.bnbNftPrice : 0

  const { notMeetRequired, notMeetThreshold } = useProfileRequirement(profileRequirement)

  return (
    <Flex flexDirection="column">
      <Flex flexDirection="column">
        {harvest && (
          <>
            <Box display="inline">
              <InlineText color="secondary" textTransform="uppercase" bold fontSize="12px">
                {`USD `}
              </InlineText>
              <InlineText color="textSubtle" textTransform="uppercase" bold fontSize="12px">
                {t('Earned')}
              </InlineText>
            </Box>
            <HarvestActions
              earnings={earnings}
              earningToken={earningToken}
              sousId={sousId}
              earningTokenPrice={earningTokenPrice}
              isBnbPool={isBnbPool}
              isLoading={isLoading}
              isFinished={pool.isFinished}
              withdrawFee={withdrawFee}
              nftPrice={nftPrice}
            />
          </>
        )}
        <Box display="inline">
          <InlineText color={isStaked ? 'secondary' : 'textSubtle'} textTransform="uppercase" bold fontSize="12px">
            {t('Stake & earn')}
          </InlineText>
          {/* <InlineText color={isStaked ? 'textSubtle' : 'secondary'} textTransform="uppercase" bold fontSize="12px">
            {isStaked ? t('Staked') : `${stakingToken.name}`}
          </InlineText> */}
        </Box>
        {notMeetRequired || notMeetThreshold ? (
          <ProfileRequirementWarning profileRequirement={profileRequirement} />
        ) : needsApproval ? (
          <ApprovalAction pool={pool} isLoading={isLoading} isIncrease={!allowance.eq(0)} />
        ) : (
          <StakeActions
            isLoading={isLoading}
            pool={pool}
            stakingTokenBalance={stakingTokenBalance}
            stakedBalance={stakedBalance}
            isBnbPool={isBnbPool}
            isStaked={isStaked}
          />
        )}
      </Flex>
    </Flex>
  )
}

export default CardActions
